import PropTypes from "prop-types";
import styles from "./ProductTile.css";
import getDealDetails from "./getDealDetails";
import ProductDescription from "./ProductDescription";
import ProductPrice from "./ProductPrice";
import SaveForLater from "./SaveForLater";
import Banners from "../Banners";
import ProductLink from "./ProductLink";
import classnames from "classnames";
import { withTranslation } from "../translation";

export const ProductTile = ({
  id,
  tileId,
  url,
  image,
  price,
  isSale,
  isOutlet,
  badgeType,
  productType,
  isSponsored,
  sponsoredCampaignId,
  sponsoredRank,
  focusOnMount,
  pageNumber,
  description,
  colourWayId,
  reducedPrice,
  formatCurrency,
  formatTranslation,
  hasMultiplePrices,
  dealBannerEnabled,
  dealBannerShownAsDiscount,
  ProductImageComponent,
  analyticsProductClick,
  anchorProductToUrl,
  className,
  isSellingFast,
  carouselCatId,
  sellingFastStyle
}) => {
  let sponsoredProps = {};
  if (isSponsored) {
    sponsoredProps = {
      sponsoredCampaignId,
      sponsoredRank
    };
  }

  const getProductTileId = id => `product-${id}`;

  const {
    formattedPrice,
    formattedReducedPrice,
    deal,
    dealAria
  } = getDealDetails({
    price,
    reducedPrice,
    formatCurrency,
    formatTranslation,
    dealBannerEnabled,
    dealBannerShownAsDiscount
  });

  return (
    <article
      id={getProductTileId(tileId)}
      className={classnames(styles.productTile, className)}
    >
      <ProductLink
        className={styles.productLink}
        href={url}
        focusOnMount={focusOnMount}
        description={description}
        price={formattedPrice}
        reducedPrice={formattedReducedPrice}
        isOutlet={isOutlet}
        dealAria={dealAria}
        badgeType={badgeType}
        hasMultiplePrices={hasMultiplePrices}
        formatTranslation={formatTranslation}
        isSponsored={isSponsored}
        isSellingFast={isSellingFast}
        analyticsProductClick={analyticsProductClick}
        anchorProductToUrl={anchorProductToUrl}
        productTileId={getProductTileId(id)}
        sponsoredProps={sponsoredProps}
        pageNumber={pageNumber}
        carouselCatId={carouselCatId}
      >
        <ProductImageComponent
          src={image}
          badgeType={badgeType}
          hasSecondImageOnHover={true}
        />
        <ProductDescription text={description} />
        <ProductPrice
          price={formattedPrice}
          isSale={isSale}
          isOutlet={isOutlet}
          reducedPrice={formattedReducedPrice}
          hasMultiplePrices={hasMultiplePrices}
        />
        <Banners
          deal={deal}
          isSponsored={isSponsored}
          isSellingFast={isSellingFast}
          sellingFastStyle={sellingFastStyle}
        />
      </ProductLink>
      {productType !== "MixMatchGroup" && (
        <SaveForLater
          productId={id}
          price={price}
          colourWayId={colourWayId}
          carouselCatId={carouselCatId}
          {...sponsoredProps}
        />
      )}
    </article>
  );
};

ProductTile.propTypes = {
  isSale: PropTypes.bool,
  isOutlet: PropTypes.bool,
  pageNumber: PropTypes.number,
  reducedPrice: PropTypes.number,
  id: PropTypes.number.isRequired,
  tileId: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  hasMultiplePrices: PropTypes.bool,
  image: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  dealBannerEnabled: PropTypes.bool,
  dealBannerShownAsDiscount: PropTypes.bool,
  description: PropTypes.string.isRequired,
  colourWayId: PropTypes.number.isRequired,
  formatCurrency: PropTypes.func.isRequired,
  formatTranslation: PropTypes.func.isRequired,
  anchorProductToUrl: PropTypes.func.isRequired,
  analyticsProductClick: PropTypes.func.isRequired,
  badgeType: PropTypes.oneOf(["MixMatch", "MoreColors"]),
  productType: PropTypes.string.isRequired,
  focusOnMount: PropTypes.bool.isRequired,
  ProductImageComponent: PropTypes.any.isRequired,
  isSponsored: PropTypes.bool.isRequired,
  sponsoredCampaignId: PropTypes.string,
  sponsoredRank: PropTypes.number,
  className: PropTypes.string,
  isSellingFast: PropTypes.bool,
  carouselCatId: PropTypes.number,
  sellingFastStyle: PropTypes.string
};

export default withTranslation(ProductTile);
